<po-page-login 
    [p-product-name]="appTitle"
    [p-background]="theme"
    [p-logo]="logo"
    [p-secondary-logo]="footerLogo"
    [p-custom-field]="tenantField"
    [p-literals]="literals"
    [p-languages]=[]
    [p-hide-remember-user]="true"
    (p-login-submit)="onLogin($event)"
    [p-loading]="isLoading"
    p-recovery="/change-password"
    p-register-url="/register"
    >
</po-page-login>